import * as yup from 'yup';

export const initialValuesStepThree = {};

export const schemaStepThree = yup.object().shape({});

export const titleStepThree = '¡Hemos recibido tu orden de compra!';
